import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
const SubSequenceButtons = ({subSequence, setSubSequence, subSequences}) => { 
    let arr = new Array(subSequences).fill(0);
    return (
        <div className="subsequence-buttons">
          {arr.map((a, i) => <Sub subSequence={i} isCurrent={subSequence === i} setSubSequence={setSubSequence}/>)}
        </div>
    );
}

const Sub = ({subSequence, isCurrent, setSubSequence}) => {
    let className = "mini-subsequence-btn";
    if (isCurrent) {
        className += " current";
    }
    return (
        <div className={className} onClick={() => setSubSequence(subSequence)}>
          {NAMES[subSequence]}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubSequenceButtons);
